import { useTranslation } from 'react-i18next';
import { SelectableTableColumn } from '../../components/SelectableTable/SelectableTable.types';

export const useCardsTableColumns = () => {
  const { t } = useTranslation();

  const columns: SelectableTableColumn[] = [
    {
      id: 'id',
      type: 'checkbox',
      title: '',
      filterType: null,
    },
    {
      id: 'tasksSolutionSheetId',
      type: 'text',
      title: t('cards:table.cardId'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'bundleNumber',
      type: 'text',
      title: t('cards:table.bundleNumber'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'bundleName',
      type: 'text',
      title: t('cards:table.bundleName'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'bundleSheetCode',
      type: 'text',
      title: t('cards:table.bundleSheetCode'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'examCommitteeId',
      type: 'text',
      title: t('cards:table.examCommitteeId'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'schoolCode',
      type: 'text',
      title: t('cards:table.examineeSchoolCode'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'examineeIdentity',
      type: 'text',
      title: t('cards:table.examineeIdentity'),
      filterType: 'search',
      sortable: true,
    },
    {
      id: 'bundleImportDate',
      type: 'date',
      title: t('cards:table.bundleImportDate'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'processingDate',
      type: 'date',
      title: t('cards:table.proccessDate'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'status',
      type: 'children',
      title: t('cards:table.status'),
      filterType: 'filter',
      sortable: true,
    },
    {
      id: 'actions',
      type: 'actions',
      title: 'Akcje',
      filterType: null,
      skipEnterMethod: true,
    },
  ];
  return {
    columns,
  };
};
